<!--
 * @Description: 新增-编辑所有字段类型
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 单行文本，超链接 ，编码-->
  <jw-input :max-length="confine.number5001" v-if="textList.includes(modulesItem?.setting?.fieldType)" v-qfeiTrim v-model="modulesItem.fieldValue" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" :disabled="modulesItem.businessData == '0' || disabledAll" :class="[isTask ? 'task-fields' : 'system-form-item-fields', modulesItem?.setting?.fieldType == 11 && modulesItem?.fieldValue && !tools.checkLink(modulesItem.fieldValue) ? 'link-item-label' : '']" @blur="fieldJoker" />
  <!-- 多行文本 -->
  <jw-textarea
    v-else-if="modulesItem?.setting?.fieldType == 1"
    :placeholder="modulesItem?.placeholder || ''"
    v-qfeiTrim
    v-model="modulesItem.fieldValue"
    :auto-size="{
      minRows: 2,
      maxRows: 5
    }"
    :max-length="confine.number10001"
    :disabled="modulesItem.businessData == '0' || disabledAll"
    class="system-form-item-fields"
    @blur="fieldJoker"
  />
  <!-- 富文本 -->
  <div v-else-if="modulesItem?.setting?.fieldType == 26" class="system-form-item-fields">
    <w-editor
      v-model="modulesItem.fieldValue"
      @blur="richOnblur"
      :isTask="isTask"
      :configs="{
        height: 300,
        editorConfig: {
          placeholder: modulesItem?.placeholder || '',
          readOnly: modulesItem.businessData == '0' || disabledAll
        }
      }"
    ></w-editor>
  </div>
  <!-- 2,3,4,5 -->
  <template v-else-if="inputList.includes(modulesItem?.setting?.fieldType)">
    <!-- 子表单的单选需要处理成下拉单选 -->
    <template v-if="from == 35">
      <!-- 单选、下拉单选 -->
      <template v-if="(modulesItem?.setting?.fieldType === 2 || modulesItem?.setting?.fieldType === 4) && modulesItem?.setting?.fieldExt">
        <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" class="system-form-item-fields" allow-clear allow-search :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker">
          <jw-option v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-option>
        </jw-select>
      </template>
      <!-- 多选、下拉多选 -->
      <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="(modulesItem?.setting?.fieldType === 3 || modulesItem?.setting?.fieldType === 5) && modulesItem?.setting?.fieldExt" :placeholder="modulesItem?.placeholder || ''" multiple class="system-form-item-fields" v-model="modulesItem.fieldValue" allow-search :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker">
        <jw-option v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-option>
      </jw-select>
      <jw-select v-else class="system-form-item-fields"></jw-select>
    </template>
    <template v-else>
      <!-- 单选按钮 -->
      <jw-radio-group v-if="modulesItem?.setting?.fieldType == 2 && modulesItem?.setting?.fieldExt && JSON.parse(modulesItem?.setting?.fieldExt)?.length <= 5" class="system-form-item-fields" v-model="modulesItem.fieldValue" @change="fieldJoker" :disabled="modulesItem.businessData == '0' || disabledAll">
        <jw-radio v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-radio>
      </jw-radio-group>
      <!-- 多选按钮 -->
      <jw-checkbox-group v-else-if="modulesItem?.setting?.fieldType == 3 && modulesItem?.setting?.fieldExt && JSON.parse(modulesItem?.setting?.fieldExt)?.length <= 5" class="system-form-item-fields" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker">
        <jw-checkbox v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-checkbox>
      </jw-checkbox-group>
      <!-- 下拉单选（单选的选项多余5个处理成下拉单选） -->
      <template v-else-if="modulesItem?.setting?.fieldExt && (modulesItem?.setting?.fieldType === 4 || (modulesItem?.setting?.fieldType === 2 && JSON.parse(modulesItem?.setting?.fieldExt)?.length > 5))">
        <!-- 商机阶段 (商机)-->

        <template v-if="modulesItem.value === 'opportunityStage'">
          <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-model="modulesItem.fieldValue" :options="JSON.parse(modulesItem?.setting?.fieldExt)" disabled :placeholder="modulesItem?.placeholder || ''"> </jw-select>
        </template>
        <template v-else>
          <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" class="system-form-item-fields" allow-clear allow-search :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker">
            <jw-option v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-option>
          </jw-select>
        </template>
      </template>
      <!-- 下拉多选 -->

      <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.fieldExt && (modulesItem?.setting?.fieldType === 5 || (modulesItem?.setting?.fieldType == 3 && JSON.parse(modulesItem?.setting?.fieldExt)?.length > 5))" :placeholder="modulesItem?.placeholder || ''" multiple class="system-form-item-fields" v-model="modulesItem.fieldValue" allow-search :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" @popup-visible-change="selectVisibleChange" @remove="selectVisibleChange(false)">
        <jw-option v-for="item in JSON.parse(modulesItem?.setting?.fieldExt)" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-option>
      </jw-select>
      <jw-select v-else class="system-form-item-fields"></jw-select>
    </template>
  </template>

  <!-- 人员选择是一个单框与角色权限中的添加人员一样 -->

  <template v-else-if="modulesItem?.setting?.fieldType === 6">
    <fh-person className="system-form-item-fields" position="bl" :maxTagCount="from == 35 ? 1 : 2" :item="modulesItem?.fieldValue?.length && modulesItem.setting.fv ? modulesItem.setting.fv : null" :disabled="modulesItem.businessData == '0' || disabledAll || formDisabled" :multiple="tools.isJSON(modulesItem?.setting?.fieldExt) ? (JSON.parse(modulesItem?.setting?.fieldExt)?.single == 1 ? false : true) : true" @cb="setModulesItem($event, modulesItem)" @popup-visible-change="selectVisibleChange" @remove="selectVisibleChange(false)"> </fh-person>
  </template>

  <!-- 数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 7">
    <jw-input-number :max-length="confine.number5000" v-if="JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat === '100'" :precision="3" v-model="modulesItem.fieldValue" :class="isTask ? 'task-fields' : 'system-form-item-fields'" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @blur="fieldJoker" @clear="fieldJoker" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll">
      <template #append> % </template>
    </jw-input-number>
    <template v-else>
      <template v-if="isFormat">
        <!-- 精度 末尾不省略0 -->
        <jw-input-number ref="inputNumberRef" :max-length="confine.number5000" :class="isTask ? 'task-fields' : 'system-form-item-fields'" v-model="modulesItem.fieldValue" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @blur="fieldJoker" @clear="fieldJoker" allow-clear :disabled="modulesItem.businessData == '0' || disabledAll" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="tools.isJSON(modulesItem?.setting?.fieldExt) ? Number(JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat) : 2">
          <template v-if="tools.isJSON(modulesItem?.setting?.fieldExt) && JSON.parse(modulesItem?.setting?.fieldExt)?.numberUnit" #append> {{ JSON.parse(modulesItem?.setting?.fieldExt)?.numberUnit || '' }} </template>
        </jw-input-number>
      </template>
      <template v-else>
        <!-- 精度 末尾省略0 -->
        <jw-input-number :max-length="confine.number5000" :class="isTask ? 'task-fields' : 'system-form-item-fields'" v-model="modulesItem.fieldValue" :placeholder="modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" @focus="handleFocus" allow-clear :disabled="modulesItem.businessData == '0' || disabledAll" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)">
          <template v-if="tools.isJSON(modulesItem?.setting?.fieldExt) && JSON.parse(modulesItem?.setting?.fieldExt)?.numberUnit" #append> {{ JSON.parse(modulesItem?.setting?.fieldExt)?.numberUnit || '' }} </template>
        </jw-input-number>
      </template>
    </template>
  </template>
  <!-- 日期格式 -->

  <!-- 日期格式 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 8">
    <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :show-time="isShowTime(modulesItem?.setting?.fieldExt)" :value-format="isShowTime(modulesItem?.setting?.fieldExt) ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" class="system-form-item-fields" :format="modulesItem?.setting?.fieldExt" position="br" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" />
  </template>

  <!-- 日期范围 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 9">
    <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-if="modulesItem?.setting?.fieldExt === '0'" v-model="modulesItem.fieldValue" class="system-form-item-fields" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" />

    <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.fieldExt === '1'" class="system-form-item-fields" v-model="modulesItem.fieldValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" />

    <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else v-model="modulesItem.fieldValue" class="system-form-item-fields" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" />
  </template>
  <!-- 级联选择器 -->
  <jw-cascader :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.fieldType === 10" :options="setDisabledOPtion(modulesItem?.setting?.fieldExt)" :placeholder="modulesItem?.placeholder || ''" class="system-form-item-fields" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || disabledAll" @change="fieldJoker" path-mode allow-clear allow-search />
  <!-- 查找关联 -->

  <template v-else-if="modulesItem?.setting?.fieldType === 12 || modulesItem?.setting?.fieldType === 25">
    <xl-association :type="from" :isTask="isTask" :singleFieldEdit="singleFieldEdit" :popup-container="popupContainer" :multiple="modulesItem?.setting?.fieldType === 25" :modules-item="modulesItem" :disabled="modulesItem.businessData == '0' || disabledAll ? true : false" :form-data="from == 35 ? getMainForm : formatData" v-model="modulesItem.fieldValue" @change="fieldJoker" @lineEdit="lineEdit" :placeholder="modulesItem?.placeholder || ''" />
  </template>
  <!-- 金额 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 16">
    <template v-if="isFormat">
      <!-- 精度 末尾不省略0 -->
      <jw-input-number ref="inputNumberRef" :disabled="modulesItem.businessData == '0' || disabledAll" @blur="fieldJoker" class="system-form-item-fields" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" @input="(event) => getPrecisionNum(event, modulesItem)" :precision="tools.isJSON(modulesItem?.setting?.fieldExt) ? Number(JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat) : Number(modulesItem?.setting?.fieldExt)" />
    </template>
    <!-- 精度 末尾省略0 -->
    <template v-else>
      <jw-input-number :disabled="modulesItem.businessData == '0' || disabledAll" @focus="handleFocus" class="system-form-item-fields" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)" />
    </template>
  </template>
  <!-- 附件 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 18 && modulesItem?.setting?.fieldExt">
    <!-- 这是支持行内编辑 -->
    <template v-if="opType == 1">
      <div class="upload-content">
        <template v-if="modulesItem?.fieldValue?.length && Array.isArray(modulesItem.fieldValue)">
          <ly-attachment-list :fieldValue="modulesItem.fieldValue" :all="false"></ly-attachment-list>
        </template>
        <jw-link class="upload-link" :disabled="modulesItem.businessData == '0' || disabledAll" @click="uploadCk">{{ t('请上传') }}</jw-link>
      </div>
    </template>
    <template v-else>
      <template v-if="JSON.parse(modulesItem?.setting?.fieldExt)?.uploadType == 2 && JSON.parse(modulesItem?.setting?.fieldExt)?.fileType == 2">
        <fh-img-watermark :fileItem="modulesItem?.fieldValue" :fieldExt="modulesItem?.setting?.fieldExt" @cb="setModulesItem($event, modulesItem)"></fh-img-watermark>
      </template>
      <template v-else>
        <fh-attachment-upload :fieldExt="modulesItem?.setting?.fieldExt" v-model="modulesItem.fieldValue" :defaultFileList="modulesItem?.fieldValue" class="system-formlumns-item-value" @cb="setModulesItem($event, modulesItem)" :disabled="modulesItem.businessData == '0' || disabledAll" :show-remove-btn="modulesItem.businessData != '0' && !disabledAll" :key="modulesItem?.isRefresh" />
      </template>
    </template>
  </template>
  <!-- 百分比 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 23">
    <template v-if="modulesItem?.setting?.fieldKey !== 'taxRate'">
      <template v-if="isFormat">
        <!--  精度 末尾不省略0 -->
        <jw-input-number ref="inputNumberRef" v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" @blur="fieldJoker" @clear="fieldJoker" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll" @input="(event) => getPrecisionNum(event, modulesItem)" :precision="tools.isJSON(modulesItem?.setting?.fieldExt) ? Number(JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat) : 2">
          <template #append> % </template>
        </jw-input-number>
      </template>
      <template v-else>
        <!-- 精度 末尾省略0 -->
        <jw-input-number v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" @focus="handleFocus" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll" :precision="getPrecision(modulesItem, precisionNum)">
          <template #append> % </template>
        </jw-input-number>
      </template>
    </template>
    <template v-else>
      <jw-input-number v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" hide-button disabled @input="(event) => getPrecisionNum(event, modulesItem)" :precision="getPrecision(modulesItem, precisionNum)">
        <template #append> % </template>
      </jw-input-number>
    </template>
  </template>
  <!-- 引用字段 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 21">
    <!-- 单行文本，超链接，编码 -->
    <jw-input v-if="textList.includes(modulesItem?.setting?.business?.fieldType)" v-model="modulesItem.fieldValue" disabled class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" />
    <!-- 多行文本 -->
    <jw-textarea
      v-else-if="modulesItem?.setting?.business?.fieldType == 1"
      v-model="modulesItem.fieldValue"
      :auto-size="{
        minRows: 2,
        maxRows: 5
      }"
      placeholder="引用字段"
      :max-length="5000"
      disabled
      class="system-form-item-fields ly-form-item-fields-disabled ly-form-item-disabled"
    />
    <div v-else-if="modulesItem?.setting?.business?.fieldType == 26" style="width: 295px">
      <w-editor
        v-model="modulesItem.fieldValue"
        :configs="{
          editorConfig: {
            placeholder: '引用字段',
            readOnly: true
          }
        }"
      ></w-editor>
    </div>

    <!-- 单选按钮 -->
    <jw-radio-group v-else-if="modulesItem?.setting?.business?.fieldType == 2 && modulesItem?.setting?.business?.fieldExt" class="system-form-item-fields" v-model="modulesItem.fieldValue" disabled placeholder="引用字段">
      <jw-radio v-for="item in JSON.parse(modulesItem?.setting?.business?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
    </jw-radio-group>
    <!-- 多选按钮 -->
    <jw-checkbox-group v-else-if="modulesItem?.setting?.business?.fieldType == 3 && modulesItem?.setting?.business?.fieldExt" class="system-form-item-fields" v-model="modulesItem.fieldValue" disabled placeholder="引用字段">
      <jw-checkbox v-for="item in JSON.parse(modulesItem?.setting?.business?.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
    </jw-checkbox-group>
    <!-- 下拉单选 -->
    <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.business?.fieldType === 4 && modulesItem?.setting?.business?.fieldExt" v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" :options="JSON.parse(modulesItem?.setting?.business?.fieldExt)" disabled placeholder="引用字段"> </jw-select>
    <!-- 下拉多选 -->
    <jw-select :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.business?.fieldType === 5 && modulesItem?.setting?.business?.fieldExt" multiple class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" :options="JSON.parse(modulesItem?.setting?.business?.fieldExt)" disabled placeholder="引用字段"> </jw-select>
    <!-- 人员选择是一个单框与角色权限中的添加人员一样 -->
    <xl-tree-member-modal v-else-if="modulesItem?.setting?.business?.fieldType === 6" ref="xlTreeMember" :tree="tree" :user="modulesItem?.setting?.business.fv?.userList" disabled :memberNumber="1" :multipleDep="tools.isJSON(modulesItem?.setting?.business?.fieldExt) ? (JSON.parse(modulesItem?.setting?.business?.fieldExt)?.single == 1 ? false : true) : true">
      <jw-input v-model="modulesItem.fieldValue" placeholder="引用字段" disabled class="system-form-item-fields ly-form-item-fields-disabled" />
    </xl-tree-member-modal>
    <!-- 数字-->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 7">
      <jw-input-number v-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.numberFormat === '100'" :precision="3" v-model="modulesItem.fieldValue" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" class="system-form-item-fields ly-form-item-fields-disabled" disabled placeholder="引用字段">
        <template #append> % </template>
      </jw-input-number>
      <jw-input-number v-else-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.numberUnit" class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" disabled placeholder="引用字段" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)">
        <template #append> {{ JSON.parse(modulesItem?.setting?.business?.fieldExt)?.numberUnit || '' }} </template>
      </jw-input-number>
      <jw-input-number v-else class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="引用字段" disabled :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)" />
    </template>
    <!-- 日期格式 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 8">
      <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-model="modulesItem.fieldValue" :show-time="isShowTime(modulesItem?.setting?.business?.fieldExt)" :value-format="isShowTime(modulesItem?.setting?.business?.fieldExt) ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" :format="modulesItem?.setting?.business?.fieldExt" position="br" disabled />
      <!-- <jw-date-picker v-else placeholder="引用字段" v-model="modulesItem.fieldValue" class="system-form-item-fields" :format="modulesItem?.setting?.business?.fieldExt" position="br" disabled /> -->
    </template>
    <!-- 日期范围 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 9">
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-if="modulesItem?.setting?.business?.fieldExt === '0'" v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" disabled />
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-else-if="modulesItem?.setting?.business?.fieldExt === '1'" class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" disabled />
      <jw-range-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-else v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" disabled />
    </template>
    <!-- 级联选择器 -->
    <jw-cascader :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-else-if="modulesItem?.setting?.business?.fieldType === 10 && modulesItem?.setting?.business?.fieldExt" :options="JSON.parse(modulesItem?.setting?.business?.fieldExt)" placeholder="引用字段" class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" disabled path-mode check-strictly />
    <!--引用字段---- 查找关联 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 12">
      <jw-input class="system-form-item-value ly-form-item-fields-disabled" v-model="modulesItem.fieldValueName" disabled placeholder="引用字段"></jw-input>
    </template>
    <!-- 金额 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 16">
      <jw-input-number disabled class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="引用字段" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)" />
    </template>
    <!-- 附件 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 18 && modulesItem?.setting?.business?.fieldExt">
      <template v-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.uploadType == 2 && JSON.parse(modulesItem?.setting?.business?.fieldExt)?.fileType == 2">
        <fh-img-watermark :fileItem="modulesItem?.fieldValue" :fieldExt="modulesItem?.setting?.business?.fieldExt" :showRemoveBtn="false"></fh-img-watermark>
      </template>
      <template v-else>
        <template v-if="modulesItem?.fieldValue?.length && Array.isArray(modulesItem.fieldValue)">
          <div class="attachments-preview-list">
            <span class="attach-item" v-for="(item, index) of modulesItem?.fieldValue" :key="item?.url" @click.stop>
              <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle" :index="index" :list="modulesItem?.fieldValue" />
            </span>
          </div>
        </template>
        <template v-else>
          <jw-input disabled class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" />
        </template>
      </template>
    </template>
    <!-- 部门 -->
    <xl-tree-member-modal v-else-if="modulesItem?.setting?.business?.fieldType === 22" ref="xlTreeMember" :tree="departTree" :depart="modulesItem?.setting.fv?.departList" disabled>
      <jw-input-tag v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" :max-tag-count="3" disabled placeholder="引用字段" />
    </xl-tree-member-modal>
    <!-- 百分比 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 23">
      <jw-input-number :precision="getPrecision(modulesItem, precisionNum)" v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" hide-button disabled>
        <template #append> % </template>
      </jw-input-number>
    </template>
    <!-- 计算类型 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 24">
      <!-- 6:金额（汇总累计) 16:金额 -->
      <template v-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type === 6 || JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type === 16">
        <jw-input-number disabled class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" placeholder="引用字段" />
      </template>
      <!-- 23：百分比 -->
      <template v-else-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type === 23">
        <jw-input-number v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" :precision="getPrecision(modulesItem, precisionNum, true)" hide-button disabled>
          <template #append> % </template>
        </jw-input-number>
      </template>
      <!-- 5:数字（汇总累计) 7:数字  -->
      <template v-else-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type == 5 || JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type == 7">
        <jw-input-number class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="引用字段" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" disabled />
      </template>
      <!-- 8:日期-->
      <template v-else-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.type === 8">
        <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-if="JSON.parse(modulesItem?.setting?.business?.fieldExt).dataType == 'YYYY/MM/DD HH:mm' || JSON.parse(modulesItem?.setting?.business?.fieldExt).dataType == 'YYYY-MM-DD HH:mm'" v-model="modulesItem.fieldValue" placeholder="引用字段" show-time :value-format="JSON.parse(modulesItem?.setting?.business?.fieldExt).dataType" lass="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.business?.fieldExt).dataType" position="br" disabled />
        <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-else v-model="modulesItem.fieldValue" placeholder="引用字段" class="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.business?.fieldExt).dataType" position="br" disabled />
      </template>
      <jw-input v-else disabled class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="引用字段" />
    </template>
    <!--引用字段---- 查找关联多选 -->
    <template v-else-if="modulesItem?.setting?.business?.fieldType === 25">
      <jw-input-tag class="system-form-item-value ly-form-item-fields-disabled" v-model="modulesItem.fieldValueName" disabled placeholder="引用字段"></jw-input-tag>
    </template>
    <template v-else>
      <jw-input disabled class="system-form-item-fields ly-form-item-fields-disabled" placeholder="引用字段" />
    </template>
  </template>
  <!-- 部门 -->

  <xl-tree-member-modal v-else-if="modulesItem?.setting?.fieldType === 22" ref="xlTreeMember" :tree="departTree" @cb="setModulesItem($event, modulesItem)" :multipleDep="modulesItem?.setting?.fieldExt == 1 ? false : true" :depart="modulesItem?.setting.fv?.departList" :disabled="modulesItem.businessData == '0' || disabledAll">
    <jw-input-tag v-model="modulesItem.fieldValue" :class="isTask ? 'task-fields' : 'system-form-item-fields'" :max-tag-count="3" readonly :disabled="modulesItem.businessData == '0' || disabledAll" :placeholder="modulesItem?.placeholder || ''" />
  </xl-tree-member-modal>

  <!-- 计算类型字段 -->
  <template v-else-if="modulesItem?.setting?.fieldType === 24">
    <!-- 5:数字（汇总累计) 7:数字  -->
    <div class="update-computed-fields">
      <template v-if="JSON.parse(modulesItem?.setting?.fieldExt)?.type == 5 || JSON.parse(modulesItem?.setting?.fieldExt)?.type == 7">
        <jw-input-number class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="计算字段" disabled :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" />
      </template>
      <!-- 6:金额（汇总累计) 16:金额 -->
      <template v-else-if="JSON.parse(modulesItem?.setting?.fieldExt)?.type === 6 || JSON.parse(modulesItem?.setting?.fieldExt)?.type === 16">
        <jw-input-number disabled class="system-form-item-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" placeholder="计算字段" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" />
      </template>
      <!-- 8:日期-->
      <template v-else-if="JSON.parse(modulesItem?.setting?.fieldExt)?.type === 8">
        <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-if="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType == 'YYYY/MM/DD HH:mm' || JSON.parse(modulesItem?.setting?.fieldExt)?.dataType == 'YYYY-MM-DD HH:mm'" v-model="modulesItem.fieldValue" placeholder="计算字段" show-time :value-format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" lass="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" position="br" disabled />

        <jw-date-picker :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" v-else v-model="modulesItem.fieldValue" placeholder="计算字段" class="system-form-item-fields ly-form-item-fields-disabled" :format="JSON.parse(modulesItem?.setting?.fieldExt)?.dataType" position="br" disabled />
      </template>
      <!-- 0:文本-->

      <jw-input v-else-if="JSON.parse(modulesItem?.setting?.fieldExt)?.type === 0" v-model="modulesItem.fieldValue" placeholder="计算字段" disabled class="system-form-item-fields ly-form-item-fields-disabled" />

      <!--23: 百分比 -->
      <template v-else-if="JSON.parse(modulesItem?.setting?.fieldExt)?.type === 23">
        <jw-input-number :precision="getPrecision(modulesItem, precisionNum, true)" v-model="modulesItem.fieldValue" class="system-form-item-fields ly-form-item-fields-disabled" placeholder="计算字段" hide-button disabled>
          <template #append> % </template>
        </jw-input-number>
      </template>
      <!-- 其他 -->
      <jw-input v-else v-model="modulesItem.fieldValue" placeholder="计算字段" disabled class="system-form-item-fields ly-form-item-fields-disabled" />

      <template v-if="errorDataMap && errorDataMap[modulesItem?.setting?.fieldKey]">
        <jw-tooltip :content="errorDataMap[modulesItem?.setting?.fieldKey]">
          <icon-exclamation-circle-fill :size="16" />
        </jw-tooltip>
      </template>
    </div>
  </template>
  <!-- 其他类型 -->
  <jw-input v-else v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="true" class="system-form-item-fields" @change="fieldJoker" />
  <!-- 附件上传弹窗 -->
  <fh-upload-modal @cb="getFieldsVal" ref="uploadModalRef" opType="1" />
</template>

<script setup>
import { tools } from '@/utils/tools.js';
import { confine } from '@/utils/const.js';
import dayjs from 'dayjs';
import useViewFields from '@/hooks/view-fields';
import { ref, computed, nextTick } from 'vue';

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

const { getDept, departmentList } = useViewFields();
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const uploadModalRef = ref(); //上传附件弹窗
const props = defineProps({
  modules: {
    //接收的数据
    type: Object,
    default: () => {}
  },
  formatData: {
    type: Array,
    default: () => []
  },
  entity: {
    type: Number || String,
    default: () => ''
  },
  id: {
    type: Number || String,
    default: () => ''
  },
  from: {
    //布局type
    // 20 ：字段  30 ：关联表格 35 ：子表单
    type: Number || String,
    default: () => 20
  },
  opType: {
    //操作类型
    // 0 普通编辑  1 表格行内编辑
    type: Number || String,
    default: () => 0
  },
  rowIndex: {
    //子表单中记录编辑的是第几行
    type: Number || String,
    default: () => ''
  },
  //30:新增 40：编辑
  type: {
    type: Number || String,
    default: 30
  },
  mainForm: {
    //主表数据
    type: Array,
    default: () => []
  },
  popupContainer: {
    //元素挂载节点支持配置，兼容部分场景中查找关联被遮盖所以可自行挂载到body下
    type: String,
    default: ''
  },
  isTask: {
    type: Boolean,
    default: false
  },
  errorDataMap: {
    // 计算字段错误信息
    type: Object
  },
  singleFieldEdit: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  formDisabled: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(['cb', 'lineEdit', 'selectPopVisibleCb']);
const modulesItem = ref(props?.modules);

const inputList = [2, 3, 4, 5]; //选项类
const textList = [0, 11, 13]; //单行，超链接，编码
// console.log('表单项', modulesItem.value);
const isFormat = ref(false);
const iconStyle = {
  width: '60px',
  height: '60px'
};
const inputNumberRef = ref();

const handleFocus = () => {
  isFormat.value = true;
  nextTick(() => {
    inputNumberRef.value?.focus();
  });
};

if (modulesItem.value?.setting?.fieldType == 4 && modulesItem.value?.value == 'entityType') modulesItem.value.fieldValue = modulesItem.value.fieldValue?.toString();
// 左侧列表选择激活态结束
// const personTree = ref({
//   checkDepartment: false
// });
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
// 是否展示时间
const isShowTime = (ext) => {
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};
// 表单所有数据
const getformatData = ref(props?.formatData);

const richOnblur = () => {
  emits('cb', '', modulesItem.value, props.rowIndex);
};

const getMainForm = ref(props?.mainForm); //主表数据

//select开关
const selectVisibleChange = (event) => {
  //校验必填/显示
  if (!event) {
    emits('selectPopVisibleCb', '', modulesItem.value, props.rowIndex);
  }
};

const fieldJoker = (id = null, item = null) => {
  isFormat.value = false;
  if (modulesItem.value?.setting?.fieldType == 25) {
    modulesItem.value['customValue'] = JSON.parse(JSON.stringify(item?.length > 0 ? item : []));
  }
  if (modulesItem.value?.setting?.fieldType == 12) {
    //兼容自定义对象 添加Object格式 { label: '名称', value: 'ID' }

    if (Array.isArray(item)) {
      modulesItem.value['customValue'] = JSON.parse(JSON.stringify(item.length ? item[0] : { label: '', value: '' }));
    } else {
      modulesItem.value['customValue'] = JSON.parse(JSON.stringify(Object.keys(item)?.length > 0 ? item : { label: '', value: '' }));
    }
  }

  console.log('fieldJoker998', id, modulesItem.value);

  //校验必填/显示
  emits('cb', '', modulesItem.value, props.rowIndex);
};

//兼容行内编辑多选查找关联反显label
const lineEdit = (item) => {
  emits('lineEdit', item);
};

const setModulesItem = ($event, modulesItem) => {
  // console.log('setModulesItem-$event',$event)
  console.log('setModulesItem-modulesItem', $event, modulesItem);
  //人员和附件
  if (modulesItem?.setting?.fieldType === 18) {
    //附件
    // console.log('附件上传中行内编辑');
    getFiles($event, modulesItem);
  } else {
    getVal($event, modulesItem); //人员和部门
  }
};
// 级联处理选项
const setDisabledOPtion = (options) => {
  const getOptions = options && tools.isJSON(options) ? JSON.parse(options) : options ?? [];
  getOptions?.forEach((option) => {
    const isEnabled = option.isEnabled;
    option['disabled'] = !isEnabled;
    if (option.children) {
      setDisabledOPtion(option.children);
    }
  });
  return getOptions;
};
// 行内编辑--上传附件
const uploadCk = () => {
  // console.log("modulesItem.value---",modulesItem.value)
  uploadModalRef.value?.openModal({ ...modulesItem.value, fieldExt: modulesItem.value?.setting?.fieldExt });
};
// 获取上传附件弹窗的回调
const getFieldsVal = (filesList) => {
  getFiles(filesList, modulesItem.value);
};
// 获取文件列表
const getFiles = (files, modulesItem) => {
  const filesList = [];
  files &&
    files.length > 0 &&
    files?.forEach((v) => {
      if (v?.response?.code == 0 && v.response?.data) {
        // const url = v.response?.data;
        // filesList.push(...url);

        const getData = v.response?.data;
        const getUrl = v.response?.signedUrl || getData?.[0]?.url;
        filesList.push({ name: getData?.[0]?.name || '', url: getUrl });
      }
      if (v.default) {
        //默认的附件
        filesList.push({ name: v.name, url: v.url });
      }
    });
  getformatData.value?.forEach((item) => {
    if ((props.from == 30 || props.from == 35) && !props.isTask) {
      //明细行或者子表单
      if (item.type == 20 && item?.setting.fieldKey == modulesItem?.setting.fieldKey) {
        item.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
        item.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
      }
      if (item.type == 35 && props.rowIndex != '') {
        //关联表格里的子表
        item?.modules?.forEach((el) => {
          if (el?.setting.fieldKey == modulesItem?.setting.fieldKey) {
            el.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
            el.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
          }
        });
      }
    } else {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20 && list?.setting.fieldKey == modulesItem?.setting.fieldKey) {
            list.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
            list.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
          }
        });
      }
    }
  });

  emits('cb', getformatData.value, modulesItem, props.rowIndex);
};
// 添加人员角色--获取部门或者用户的值
const getVal = async (v, modulesItem) => {
  console.log('获取人员信息', v, JSON.parse(JSON.stringify(modulesItem)));

  // console.log('setModulesItem', v, getformatData);
  const userNames = modulesItem?.setting?.fieldType === 6 ? computed(() => v?.userList?.map((u) => u.userName)) : computed(() => v?.departList?.map((u) => u.departmentName));
  const departListIDs = modulesItem?.setting?.fieldType === 22 ? v.departList?.map((u) => u.id) : [];
  const userIDs = modulesItem?.setting?.fieldType === 6 ? v.userList?.map((u) => u.id) : [];
  if (modulesItem?.setting?.fieldKey == 'chargePerson' || modulesItem?.setting?.fieldKey == 'followUser') {
    //线索是跟进人
    //针对负责人和部门做特殊处理
    await getDept({
      departmentId: departListIDs,
      userId: userIDs
    });
  }

  if (userNames.value) {
    getformatData.value?.forEach((item) => {
      if (props.from == 30 || props.from == 35) {
        //关联表格或者子表单
        if (item.type == 20) {
          if (item.value == modulesItem.value) {
            item.fieldValue = userNames.value;
            item.setting.fv = v;
          }
        }
        if (item.type == 35) {
          //关联表格里的子表
          item?.modules?.forEach((el) => {
            if (el?.setting?.fieldKey == modulesItem.value) {
              el.fieldValue = userNames.value;
              el.setting.fv = v;
            }
          });
        }
      } else {
        // eslint-disable-next-line no-debugger
        // debugger;
        if (item?.modules) {
          item?.modules.forEach((list) => {
            if (list.type == 20) {
              if (list.value == modulesItem.value) {
                list.fieldValue = userNames.value;
                list.setting.fv = v;
              }
              if (modulesItem.value == 'chargePerson' || modulesItem.value == 'followUser') {
                //修改负责人时更新部门信息
                if (list.value == 'departmentIds') {
                  list.fieldValue = departmentList.value && departmentList.value[0]?.name ? [departmentList.value[0]?.name] : [];
                  list.setting.fv = {
                    departList:
                      departmentList.value && departmentList.value[0]?.name
                        ? [
                            {
                              departmentName: departmentList.value[0]?.name,
                              id: departmentList.value[0]?.id
                            }
                          ]
                        : []
                  };
                }
              }
            }
          });
        }
      }
    });
  }

  console.log('人员抛出333', JSON.parse(JSON.stringify(modulesItem)), props.rowIndex);

  emits('cb', getformatData.value, modulesItem, props.rowIndex);
};
</script>

<style scoped lang="less">
@import './ly-update-fields.less';
</style>
